import React from "react";
import { formattedAmount } from "../../../utils/helpers/Functions.helper";
import { CiLocationOn } from "react-icons/ci";
import { BsTelephone } from "react-icons/bs";
import Tooltip from "../../../components/Tooltip/Tooltip";

const VendorAndCustomerDetails = ({ deliveryDetails, vendorDetails }) => {
  return (
    <>
      {deliveryDetails ? (
        <div>
          <h3 className="font-semibold mb-2 text-lg">Order by</h3>
          <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
            {deliveryDetails?.name ?? "N/A"}
          </p>
          <div className="flex justify-start gap-2 items-center mt-1">
            <BsTelephone className="text-2xl text-blue-900 hover:text-green700 transition duration-300" />
            <p className="text-gray500 text-xl hover:text-blue-900 transition duration-300">
              {deliveryDetails?.phone_number ?? "N/A"}
            </p>
          </div>

          <div className="flex items-center p-2 gap-4 mt-4 bg-gray100 rounded-lg shadow-sm">
            <CiLocationOn className="text-3xl text-blue-900" />
            <p className="text-gray700">
              {deliveryDetails?.flat_no ?? "N/A"},{" "}
              {deliveryDetails?.landmark ?? "N/A"},
              {deliveryDetails?.street ?? "N/A"},{" "}
              {deliveryDetails?.pin_code ?? "N/A"}
            </p>
          </div>
        </div>
      ) : (
        ""
      )}
      <hr />
      {vendorDetails ? (
        <div>
          <h3 className="font-semibold mt-4 mb-2 text-lg">Vendor Details</h3>
          <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
            {vendorDetails?.first_name ?? "N/A"}
          </p>
          <div className="flex items-center p-2 gap-4 mt-4 bg-gray100 rounded-lg shadow-sm">
            <CiLocationOn className="text-3xl text-blue-900" />
            <p className="text-gray700">{vendorDetails?.address ?? "N/A"}</p>
          </div>
        </div>
      ) : (
        ""
      )}
      <hr />
    </>
  );
};




const VendorEarnings = ({ vendorEarnings, ProductDeatils }) => (
  <div>
    <h3 className="font-semibold mb-2 text-lg">Vendor Earnings</h3>
    <div>
      <h3 style={{ fontWeight: "700" }}>Product Details</h3>
      <p>
        <b>Product:</b> {ProductDeatils?.product?.name || ""}
      </p>
      <p>
        <b>Quantity:</b> {ProductDeatils?.quantity || ""}
      </p>
      <p>
        Product Base Price:{" "}
        {formattedAmount(
          parseFloat(
            ProductDeatils?.product?.sales_price?.$numberDecimal ||
              ProductDeatils?.product?.sales_price
          ).toFixed(2)
        )}
      </p>
      <p>
        Total Price:{" "}
        {formattedAmount(
          parseFloat(
            ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price
          ).toFixed(2)
        )}
      </p>
    </div>
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th className="text-right">Rate</th>
          <th className="text-right">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan={2}>Product Base Price</td>
          <td className="text-right">
            {formattedAmount(
              ProductDeatils?.product?.sales_price?.$numberDecimal
            )}
          </td>
        </tr>
        {ProductDeatils?.product?.taxData?.standardTax?.map((t, i) => (
          <tr key={i}>
            <td>{t.name}</td>
            <td className="text-right">{t?.rate.$numberDecimal || t?.rate}%</td>
            <td className="text-right">
              {formattedAmount(t?.taxAmount?.$numberDecimal || t?.taxAmount)}
            </td>
          </tr>
        ))}
        <tr>
          <td colSpan={2} className="font-bold">
            Rebase Amount
          </td>
          <td className="text-right">
            {formattedAmount(
              ProductDeatils?.product?.taxData?.rebase?.$numberDecimal
            )}
          </td>
        </tr>
        <tr>
          <td>{ProductDeatils?.product?.taxData?.vat?.[0]?.name} <Tooltip text={"This amount is calculated on Rebase Amount"} /></td>
          <td className="text-right">
            {ProductDeatils?.product?.taxData?.vat?.[0]?.rate?.$numberDecimal}%
          </td>
          <td className="text-right">
            {formattedAmount(vendorEarnings.taxAmount)}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="font-bold">
            Total
          </td>
          <td className="text-right">
            {formattedAmount(vendorEarnings.total)}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

const AdminEarnings = ({ adminEarnings }) => (
  <div>
    <h3 className="font-semibold mb-2 text-lg">Admin Earnings</h3>
    <table>
      <thead>
        <tr>
          <th>Fee Type</th>
          <th className="text-right">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan={2} className="text-center font-bold">
            Earning From Vendor
          </td>
        </tr>
        <tr>
          <td>Closing Fee</td>
          <td className="text-right">
            {formattedAmount(adminEarnings.fromVendor.closingFee)}
          </td>
        </tr>
        <tr>
          <td>Additional Fee</td>
          <td className="text-right">
            {formattedAmount(adminEarnings.fromVendor.additionalFee)}
          </td>
        </tr>
        <tr>
          <td>
            Referral Fee @ ({adminEarnings.fromVendor.referralFee.percentage}%)
          </td>
          <td className="text-right">
            {formattedAmount(adminEarnings.fromVendor.referralFee.amount)}
          </td>
        </tr>
        <tr>
          <td>VAT</td>
          <td className="text-right">
            {formattedAmount(adminEarnings.fromVendor.vat)}
          </td>
        </tr>
        <tr>
          <td>Total (From Vendor)</td>
          <td className="text-right">
            {formattedAmount(adminEarnings.fromVendor.total)}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="text-center font-bold">
            Earning From Deliveryman
          </td>
        </tr>
        <tr>
          <td>Server Fee</td>
          <td className="text-right">
            {formattedAmount(
              adminEarnings.fromDeliveryMan.shippingHandlingFeeFixedRate
            )}
          </td>
        </tr>
        <tr>
          <td>
            Shippning Fee @ (
            {adminEarnings.fromDeliveryMan.shippingFeeRate.percentage}%)
          </td>
          <td className="text-right">
            {formattedAmount(
              adminEarnings.fromDeliveryMan.shippingFeeRate.amount
            )}
          </td>
        </tr>
        <tr>
          <td>VAT</td>
          <td className="text-right">
            {formattedAmount(adminEarnings.fromDeliveryMan.vat)}
          </td>
        </tr>
        <tr>
          <td>Total (From Deliveryman)</td>
          <td className="text-right">
            {formattedAmount(adminEarnings.fromDeliveryMan.total)}
          </td>
        </tr>
        <tr>
          <td>Total Earnings</td>
          <td className="text-right">{formattedAmount(adminEarnings.total)}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

const DeliverymanEarnings = ({ deliverymanEarnings }) => (
  <div>
    <h3 className="font-semibold mb-2 text-lg">Deliveryman Earnings</h3>
    <table>
      <thead>
        <tr>
          <th>Factor Name</th>
          <th className="text-right">Value</th>
          <th className="text-right">Amount</th>
        </tr>
      </thead>
      <tbody>
        {deliverymanEarnings.factors.map((factor) => (
          <tr key={factor._id}>
            <td>{factor.name}</td>
            <td className="text-right">{factor.value}%</td>
            <td className="text-right">{formattedAmount(factor.amount)}</td>
          </tr>
        ))}
        <tr>
          <td colSpan={2} className="text-right">
            Total
          </td>
          <td className="text-right">
            {formattedAmount(deliverymanEarnings.total)}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

const EarningDetails = ({ ProductDeatils, deliveryDetails, vendorDetails }) => {
  const earningsData = {
    rebaseAmount: ProductDeatils?.product?.taxData.rebase,
    tax: {
      name: ProductDeatils?.product?.taxData.vat?.[0].name,
      rate: ProductDeatils?.product?.taxData.vat?.[0].rate,
    },
    vendorEnings: {
      taxAmount: ProductDeatils?.product?.taxData.vendorEarning.vat,
      total:
        ProductDeatils?.product?.taxData.vendorEarning.total.$numberDecimal,
    },
    adminEarnsFromVendor: {
      adminEarnFromVendor: ProductDeatils?.product?.taxData.adminEarning,
      adminEarnFromDeliveryMan: ProductDeatils?.delivery_fee.adminEarning,
    },
    deliveryManEarnings: ProductDeatils?.delivery_fee.deliveryMan,
    adminTotalEarnings:
      +ProductDeatils?.product?.taxData?.adminEarning?.total?.$numberDecimal +
      +ProductDeatils?.delivery_fee?.adminEarning?.total,
  };

  const vendorEarnings = {
    taxAmount: parseFloat(earningsData.vendorEnings.taxAmount.$numberDecimal),
    total: parseFloat(earningsData.vendorEnings.total),
  };

  const adminEarnings = {
    fromVendor: {
      closingFee: parseFloat(
        earningsData.adminEarnsFromVendor.adminEarnFromVendor.closingFee
          .$numberDecimal
      ),
      additionalFee: parseFloat(
        earningsData.adminEarnsFromVendor.adminEarnFromVendor.additionalFee
          .$numberDecimal
      ),
      referralFee: {
        percentage: parseFloat(
          earningsData.adminEarnsFromVendor.adminEarnFromVendor.referralFee
            .percentage.$numberDecimal
        ),
        amount: parseFloat(
          earningsData.adminEarnsFromVendor.adminEarnFromVendor.referralFee
            .amount.$numberDecimal
        ),
      },
      vat: parseFloat(
        earningsData.adminEarnsFromVendor.adminEarnFromVendor.vat.$numberDecimal
      ),
      total: parseFloat(
        earningsData.adminEarnsFromVendor.adminEarnFromVendor.total
          .$numberDecimal
      ),
    },
    fromDeliveryMan: {
      shippingHandlingFeeFixedRate:
        earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan
          .shippingHandlingFeeFixedRate,
      shippingFeeRate: {
        percentage:
          earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan
            .shippingFeeRate.percentage,
        amount:
          earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan
            .shippingFeeRate.amount,
      },
      vat: earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan.vat,
      total: earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan.total,
    },
    total: earningsData.adminTotalEarnings,
  };

  const deliverymanEarnings = {
    factors: earningsData.deliveryManEarnings.factor.map((factor) => ({
      name: factor.name,
      value: factor.value,
      amount: factor.amount,
      _id: factor._id,
    })),
    total: earningsData.deliveryManEarnings.total,
  };

  return (
    <div id="invoice-POS" className="printable">
      <VendorAndCustomerDetails
        deliveryDetails={deliveryDetails}
        vendorDetails={vendorDetails}
      />
      <br />
      <VendorEarnings
        vendorEarnings={vendorEarnings}
        ProductDeatils={ProductDeatils}
      />
      <DeliverymanEarnings deliverymanEarnings={deliverymanEarnings} />
      <AdminEarnings adminEarnings={adminEarnings} />
      <div className="flex justify-between items-center border-t-2 ">
        <h3 className="font-bold">Net Total</h3>
        <p className="text-right font-bold">
          {formattedAmount(
            parseFloat(
              ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price
            ).toFixed(2)
          )}
        </p>
      </div>
    </div>
  );
};

export default EarningDetails;
